/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates how the images will be stretched.
 */
export var ImageStretchOptions = /*@__PURE__*/ (function (ImageStretchOptions) {
    /**
     * Images stretch but try to maintain aspect ratio.
     */
    ImageStretchOptions[ImageStretchOptions["Uniform"] = 0] = "Uniform";
    /**
     * Image fills all available space but breaks aspect ratio.
     */
    ImageStretchOptions[ImageStretchOptions["Fill"] = 1] = "Fill";
    /**
     * Image is displayed unstreteched.
     */
    ImageStretchOptions[ImageStretchOptions["None"] = 2] = "None";
    return ImageStretchOptions;
})({});
/**
 * @hidden
 */
export var ImageStretchOptions_$type = /*@__PURE__*/ markEnum('ImageStretchOptions', 'Uniform,0|Fill,1|None,2');
//# sourceMappingURL=ImageStretchOptions.js.map
